import Swiper, { Mousewheel, FreeMode } from 'swiper';

const classes = {
  wrapperCenter: 'swiper-wrapper--center',
};

const paginatedPrintCollections = () => ({
  selectedIdx: 0,
  groups: [],

  /**
   * Centers the wrapper swiper fully fits in container.
   */
  swiperCenterOnNoScroll: (swiper) => {
    const isSwipeable = swiper.virtualSize > swiper.size;

    if (!isSwipeable) {
      swiper.wrapperEl?.classList.add(classes.wrapperCenter);
    } else {
      swiper.wrapperEl?.classList.remove(classes.wrapperCenter);
    }
  },

  cacheNodes() {
    this.swiperTabsEl = this.$root.querySelector('.swiper[swiper-tab-bank]');
    this.tabEls = this.$root.querySelectorAll('.js-prints-tab');
    this.groupEls = this.$root.querySelectorAll('.js-prints-group');
  },

  setData() {
    this.groups = [...this.groupEls].map((groupEl) => {
      const itemCount = groupEl.querySelectorAll('.js-prints-card').length;
      return { itemCount };
    });
  },

  buildSwipers() {
    if (this.swiperTabsEl) {
      this.swiperTabsInstance = new Swiper(this.swiperTabsEl, {
        slidesPerView: 'auto',
        on: {
          ppClick: (_, event) => {
            event.target.dispatchEvent(new CustomEvent('swiper-tap'));
          },
          init: this.swiperCenterOnNoScroll,
          resize: this.swiperCenterOnNoScroll,
        },
        modules: [Mousewheel, FreeMode],
        mousewheel: {
          forceToAxis: true,
        },
        freeMode: {
          momentum: false,
        },
      });
    }
  },

  init() {
    this.cacheNodes();
    this.setData();
    this.buildSwipers();
  },
});

export default paginatedPrintCollections;
